module.exports = __webpack_public_path__ + "static/media/icon-piece3-6.8f2242ea.png";